
export const environment = {
    production: false,
    apiURL: "https://awsdevapi.eviewiot.com/api",
    appLogoPath: "assets/images/logo.png",
    IDSAuthority: 'https://login.iotconnect.io',
    IDSClientID: 'iotconnect.awspoc',
    IDSScope: 'openid profile iotconnect.api.fullaccess',
    IDSArcValue: 'solutionCode:714381BD-BE54-4A8B-AB1C-DCAFBABA1F08',
    response_type: "id_token token",
    redirect_uri: 'https://awsdev.eviewiot.com/callback',
    post_logout_redirect_uri: 'https://awsdev.eviewiot.com',
    google_Key: 'AIzaSyApnqZBcCR8LRkPVvA3MO4e-72utE0mePU',
    s3BucketUrl: 'https://engenuity-{module}{accountId}.s3.us-east-1.amazonaws.com',
    cpId: 'c8322f145f9a44fcb5eb20e73b36c276',
    isDedicated: false,
    signalRUrl: 'https://poc-iotconnect-webapp-signalr-eu2.azurewebsites.net',
    googleMapsApiKey: 'AIzaSyApnqZBcCR8LRkPVvA3MO4e-72utE0mePU',
    paginationPageSize: 10,
    maxJITPRule: 5,
    maxJITPRegex: 20,
    paginationPageSizeSelector: [10, 20, 50, 100],
    publicInboxDomains: ['mailinator.com', 'yopmail.com', 'anonaddy.com', 'maildrop.cc', 'spamgourmet.com', '10minutemail.net', 'mozmail.com', 'guerrillamail.com', 'leafzie.com', 'burnermail.io', 'getnada.com'],
    accountId: ''
};